const blue = '#1da1f2'
const darkBlue = '#1e99e5'
const lightBlue = '#3db2fa'
const lightestBlue = '#e8f5fd'

module.exports = {
  'blue': blue,
  'dark-blue': darkBlue,
  'light-blue': lightBlue,
  'lightest-blue': lightestBlue,
  'font-family':
    'Lato, system, -apple-system, ".SFNSText-Regular", "San Francisco", Roboto, "Segoe UI", "Helvetica Neue", "Lucida Grande", sans-serif',
  'avatar-size-lg': '8rem',
  'avatar-border-radius': 0,
  'form-item-margin-bottom': '1rem',
  'upload-pictrue-card-size': '8rem',
  'secondary-color': '#757575',
  'disabled-color': '#9B9B9B',
  'info-color': '#0066CC',
  'success-color': blue,
  'processing-color': blue,
  'error-color': '#FC5457',
  'highlight-color': blue,
  'warning-color': '#FB9215',
  'normal-color': '#4A4A4A',
  'font-weight-light': 300,
  'font-weight-regular': 400,
  'font-weight-bold': 700,
  'font-weight-black': 900,
  'btn-primary-bg': blue,
  'border-color': '#CCC',
  'border-active-color': lightBlue,
  'link-hover-color': darkBlue,
  'item-active-bg': lightestBlue,
  'item-hover-bg': darkBlue,
  // 'link-color': '#1DA57A',
  // 'font-size-base': '1rem',
  // 'font-size-lg': '1.125rem',
  // 'font-size-sm': '0.75rem',
  // 'padding-xs': '0.5rem',
  // 'padding-sm': '0.75rem',
  // 'padding-md': '1rem',
  // 'btn-default-bg': '#7ed321',
  // 'btn-default-color': 'white',
  // 'btn-default-border': '#7ed321',
  // 'btn-padding-base': '0 2rem',
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/theme.js
// module id = 588
// module chunks = 0